import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kiene-tierarzt',
    templateUrl: './tierarzt.component.html',
    styleUrls: ['./tierarzt.component.css'],
})
export class TierarztComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
